import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetSiteSamlLoginInfoResult } from '../types/IGetSiteSamlLoginInfoResult';
import { ILoginParams } from '../types/ILoginParams';

export class GetSiteSamlLoginInfoRequest extends Request<ILoginParams, IGetSiteSamlLoginInfoResult> {
  constructor(params: ILoginParams) {
    super('getSiteSamlLoginInfo', params);
  }
}
